import { isWithinIframe } from 'app/containers/App/EmbeddedAuth/EmbedderHelpers';

import { config } from 'utils/config';

const forceAuth0InIframe = config.USE_AUTH0_IN_IFRAME === 'true';
export const useShouldUseEmbeddedAuth = (): boolean => isWithinIframe && !forceAuth0InIframe;
